import { CommonModule } from '@angular/common'
import { Component, computed, input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'

export type PageHeaderMenuItem = Readonly<{
  label: string
  disabled?: boolean
  onClick: () => void,
}>

@Component({
  selector: '[app-page-header]',
  imports: [CommonModule, MatIcon, MatIconButton, MatMenu, MatMenuItem, MatMenuTrigger],
  template: `
    <div class='page-header'>
      <h1>{{ header() }}</h1>
      <div class='content'>
      <ng-content/>
      @for (item of toolbarMenuItems(); track $index) {
        <button class='action-btn ml-1' [disabled]="item.disabled" (click)="item.onClick()">
          {{ item.label }}
        </button>
      }
      @if (dropdownMenuItems().length > 1) {
        <mat-menu #menu="matMenu">
          @for (item of dropdownMenuItems(); track $index) {
            <button mat-menu-item (click)="item.onClick()" [disabled]="item.disabled">
              {{ item.label }}
            </button>
          }
        </mat-menu>
        <button class="action-btn icon" mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon fontIcon='menu' />
        </button>
      }
    </div>
  </div>`,
  styles: `
    .page-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 6rem);
      margin: 1rem 3rem 0 3rem;
      padding: 1rem 0 0.5rem 0;

      h1 {
        margin: 0;
        font-size: 2rem;
      }

      .content {
        display: flex;
        gap: 1rem;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }
  `,
})
export class PageHeaderComponent {
  readonly header = input.required<string>()
  readonly menuItems = input<readonly PageHeaderMenuItem[]>([])
  readonly maxToolbarMenuItems = input(3)

  readonly toolbarMenuItems = computed((): readonly PageHeaderMenuItem[] =>
    this.menuItems().length > this.maxToolbarMenuItems() ? [] : this.menuItems(),
  )

  readonly dropdownMenuItems = computed((): readonly PageHeaderMenuItem[] =>
    this.menuItems().length <= this.maxToolbarMenuItems() ? [] : this.menuItems(),
  )
}
